import { useEffect, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { useCurrentUIMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { useListingLibBulkActions } from 'framework-listing-lib/internal/Table/providers/ListingLibBulkActionsProvider';
import { BULK_SELECTION_MODE } from 'framework-listing-lib/constants/table';
import { SET_BULK_SELECTION_MODE } from 'framework-listing-lib/constants/tableEvents';
import { useEffectEvent } from 'framework-listing-lib/internal/hooks/useEffectEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibBulkActionsComponent({
  clearSelection,
  querySelected,
  selection
}) {
  const currentUIMode = useCurrentUIMode();
  const {
    handleSelectFrameworkDataTableRows,
    hasBulkActions,
    renderBulkActions,
    selectedIds,
    selectedObjects,
    selectedObjectsCount,
    selectionMode
  } = useListingLibBulkActions();
  const handleSelectFrameworkDataTableRowsStable = useEffectEvent(handleSelectFrameworkDataTableRows);
  useEffect(() => {
    const checkboxEl = document.querySelector(`[data-test-id="checkbox-select-all"] label input[type="checkbox"]`);
    const hasSelectedAllCheckbox = Boolean(checkboxEl && checkboxEl.checked);
    let newSelectionMode = BULK_SELECTION_MODE.NONE;
    if (querySelected) {
      newSelectionMode = BULK_SELECTION_MODE.ALL;
    } else if (hasSelectedAllCheckbox) {
      newSelectionMode = BULK_SELECTION_MODE.ALL_ON_PAGE;
    } else {
      newSelectionMode = BULK_SELECTION_MODE.PARTIAL;
    }
    handleSelectFrameworkDataTableRowsStable({
      selectedIds: Array.from(selection).map(Number),
      selectionMode: newSelectionMode
    });
    return () => {
      // reset state on unmount
      listingLibObserver.setBulkActionsState({
        selectedIds: [],
        selectedObjects: [],
        selectedObjectsCount: 0,
        selectionMode: BULK_SELECTION_MODE.NONE
      });
      handleSelectFrameworkDataTableRowsStable({
        selectedIds: [],
        selectionMode: BULK_SELECTION_MODE.NONE
      });
    };
  }, [handleSelectFrameworkDataTableRowsStable, querySelected, selection]);
  const handleClearAll = useEffectEvent(clearSelection);
  useEffect(() => {
    function handleBulkSelectionModeChange(newSelectionMode) {
      if (newSelectionMode === BULK_SELECTION_MODE.NONE) {
        handleClearAll();
      }
    }
    listingLibObserver.on(SET_BULK_SELECTION_MODE, handleBulkSelectionModeChange);
    return () => {
      listingLibObserver.off(SET_BULK_SELECTION_MODE, handleBulkSelectionModeChange);
    };
  }, [handleClearAll]);
  const bulkActionsProps = useMemo(() => ({
    selectedIds,
    selectedObjects,
    selectedObjectsCount,
    selectionMode,
    onClearSelection: clearSelection,
    uiMode: currentUIMode
  }), [clearSelection, currentUIMode, selectedIds, selectedObjects, selectedObjectsCount, selectionMode]);
  if (!hasBulkActions || !renderBulkActions) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    flexGrow: 1,
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "detail-100",
      "data-test-id": "crm-listing-bulk-actions",
      children: /*#__PURE__*/_jsx(Flex, {
        children: renderBulkActions(bulkActionsProps)
      })
    })
  });
}